import React from 'react'

const Footer = () => {
    return (
        <div className="mb-1 p-2  text-white bg-gradient-to-r from-[#3F8CCB] to-[#129FDA] capitalize font-overpass" >
            <div className="flex justify-center">
                <div className="flex justify-start mt-2">
                    <a href="https://www.facebook.com/ConsulmedARG/" target="_blank" rel="noopener noreferrer" alt="Perfil de Facebook" title="Perfil de Facebook"><i className="fab fa-facebook-square fa-2x -mt-1 mb-2 mr-2" ></i></a>
                    <a href="https://www.twitter.com/consulmed" target="_blank" rel="noopener noreferrer" alt="Perfil de Twitter" title="Perfil de Twitter"><i className="fab fa-twitter-square fa-2x -mt-1 mb-2 mr-2" ></i></a>
                    <a href="https://www.instagram.com/consulmedodontologia/" target="_blank" rel="noopener noreferrer" clear alt="Perfil de Instagram" title="Perfil de Instagram"><i className="fab fa-instagram fa-2x -mt-1 mb-2 mr-2" ></i></a>
                </div>
            </div>
            <div className="flex justify-center font-overpass">
                <p className="flex justify-start text-xs -mt-1 text-stone-100">ⒸCopyright 2023 Consulmed. Todos los derechos reservados.</p>
            </div>
        </div>
    )
}
export default Footer;